import { render } from "./AddToCollectionCard.vue?vue&type=template&id=7788fc8b&scoped=true"
import script from "./AddToCollectionCard.vue?vue&type=script&lang=js"
export * from "./AddToCollectionCard.vue?vue&type=script&lang=js"

import "./AddToCollectionCard.vue?vue&type=style&index=0&id=7788fc8b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7788fc8b"]])

export default __exports__